import api from '@/common/http'

const ai = {
  state: {
    tenantId: sessionStorage.getItem('__tenantId__') || "242873", // 租户id
    bot_id: sessionStorage.getItem('__ai_bot_id__') || "7482047421262970934", // "7483092762343768099", // 测试专用
    connector_id: "", // 渠道id
    user_id: sessionStorage.getItem('__ai_user_id__') || "",
    ai_token: sessionStorage.getItem('__ai_token__') || "" // "Bearer pat_WTn0UAzYZT2NjdwJgUTDvbZF0vPFq5V5Y5gNQ7MEviQqKdd08l078bkNEQpzslWZ"
  },
  mutations: {
    SET_BOT_ID(state, bot_id) {
      state.bot_id = bot_id
      sessionStorage.setItem('__ai_bot_id__', state.bot_id)
    },
    SET_USER_ID(state, user_id) {
      state.user_id = user_id
      sessionStorage.setItem('__ai_user_id__', state.user_id)
    },
    SET_AI_TOKEN(state, ai_token) {
      state.ai_token = ai_token
      sessionStorage.setItem('__ai_token__', state.ai_token)
    },
    SET_TENANT_ID(state, tenantId) {
      state.tenantId = tenantId
      sessionStorage.setItem('__tenantId__', state.tenantId)
    }
  },
  actions: {
    getToken({ state, commit }) {
      return new Promise((resolve, reject) => {
        api.getCozeJwtToken({ userId: state.user_id }).then(res => {
          if (res.code === 1000) {
            const { access_token, token_type } = res.data
            commit('SET_AI_TOKEN', `${token_type} ${access_token}`)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(() => {
          reject(res)
        })
      })
    },
  }
}

export default ai;